// Manually created API, should refactor backend so we can generate needed endpoints.
import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

type GetHomeResponse = {
    filterlist: {
        databases: Array<{id: string; name: string}>;
    };
};

export const dibadminApiManual = createApi({
    reducerPath: "dibadminApiManual",
    baseQuery: fetchBaseQuery({baseUrl: "/dibapi"}),
    endpoints: (build) => ({
        getHome: build.query<GetHomeResponse, void>({
            query: () => ({
                url: "/api/home",
                method: "GET",
            }),
            extraOptions: {
                maxRetries: 3,
            },
        }),
    }),
});

export const {useGetHomeQuery} = dibadminApiManual;
